

















import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwFireplaceCount from "./FireplaceCount.vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwFireplaceCount: iwFireplaceCount,
        iwInputCheckbox: iwInputCheckbox,
    },
    data: function () {
        return {
            pathInStoreFireplaceCount: "property.livingDescription.fireplace.count",
            pathInStoreUI: "property.hasFireplace",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","APARTMENT","OTHER", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },

        fireplaceCount: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreFireplaceCount);
        },

        fireplaceCountInput: function(): Vue {
            return (this.$refs.fireplaceCount as Vue).$refs.fireplaceCountInput as Vue;
        },

        hasFireplace: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
            },

            set: function(value: boolean) {
                this.$store.commit("FormModule/addValueUI", {
                    path: this.pathInStoreUI,
                    value: value,
                });

                if (value) {
                    // Make sure count is at least 1 when checked.
                    if (!this.fireplaceCount) {
                        this.$store.dispatch("FormModule/addValue", {
                            path: this.pathInStoreFireplaceCount,
                            value: 1,
                        });

                        this.fireplaceCountInput.$data.internalValue = 1;
                    }
                } else {
                    // Remove count when unchecked.
                    this.deleteValuePath(this.pathInStoreFireplaceCount);
                }
            },
        },
    },
    created: function() {
        this.hasFireplace = Boolean(this.fireplaceCount);
    },

    methods: {
        ...mapActions({
            deleteValuePath: "FormModule/deleteValuePath",
        }),
    }
});

